export default function findCycleByCalendarAndDate(calendarId, date) {
  const dateInMilli = date.getTime();
  return `{
    findCycleByCalendarAndDate(calendarId: ${calendarId}, dateInMilli: ${dateInMilli}) {
        sequence
    }
}`;
}
